<template>
  <div class="container">
    <!-- <nav-bar leftName="返回" rightName="保存" @leftClick="leftClick" @rightClick="handleRightClick"></nav-bar> -->
    <no-data v-if="city.length === 0" :text="text" :imgSrc="imgSrc"></no-data>
    <city-list v-else :city="city" :title="pName"></city-list>
    <div class="cut" @click="selectCity" v-show="city.length !== 0"><span class="iconfont">&#xe647;</span>切换城市</div>
    <button class="btn-block btn-save" :class="city.length === 0 ? 'btn-disable' : ''" @click="handleRightClick">保存</button>
    <setting-internet v-if="showTip" @next="nextUpdate" @now="nowUpdate"></setting-internet>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure"></ttip-select>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import CityList from './components/list.vue'
import NoData from '../../components/NoData/NoData.vue'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import Common from '../../assets/js/common.js'
import axios from 'axios'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    CityList,
    NavBar,
    NoData,
    SettingInternet,
    TtipSelect
  },
  data () {
    return {
      locationId: null,
      pName: localStorage.getItem('max_p_name'),
      cityBase: this.$route.query,
      city: localStorage.getItem('max_city') ? localStorage.getItem('max_city').split('.') : [],
      showTip: false,
      showSelectTip: false,
      imgSrc: Common.staticHref() + 'img/position.jpg',
      text: '设备暂未联网，无法定位',
      deviceId: localStorage.getItem('max_device_id'),
      selectTimes: 0,
      quit: false
    }
  },
  mounted () {
    Common.setTitle('城市选择')
    this.verify()
    this.getCityList()
    // this.getWeather()
  },
  methods: {
    pushHistory () {
      let state = {
        title: '',
        url: '/' + isLocal
      }
      window.history.pushState(state, state.title, state.url)
    },
    popstate () {
      if (this.showTip) {
        this.showTip = false
        this.$router.back()
      } else if (this.showSelectTip) {
        this.showSelectTip = false
        if (this.quit) {
          this.$router.back()
        } else {
          this.pushHistory()
        }
      } else {
        if (!this.quit) {
          if (this.locationId) {
            this.showSelectTip = !this.showSelectTip
            this.pushHistory()
          }
        }
      }
    },
    verify () {
      var _this = this
      window.addEventListener('popstate', _this.popstate, false)
    },
    cancelBack () {
      var _this = this
      window.removeEventListener('popstate', _this.popstate)
    },
    addHistory () {
      if (this.selectTimes === 0) {
        this.selectTimes++
        this.pushHistory()
      }
    },
    selectCity () {
      this.addressPicker.show()
    },
    handleRightClick () {
      if (this.city.length === 0) return
      if (!this.locationId) {
        this.$createToast({
          type: 'correct',
          txt: '请选择要更改的城市',
          time: 2000
        }).show()
      } else {
        this.setLocation()
      }
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      let locationInfo = selectedVal[2]
      this.locationId = locationInfo.split('$$')[0]
      this.addHistory()
      if (selectedText[1] === selectedText[0]) {
        this.city = selectedText.splice(1)
      } else {
        this.city = selectedText
      }
    },
    cancelHandle () {},
    leftClick () {
      if (!this.locationId) {
        this.$router.push({path: '/Setting'})
      } else {
        this.showSelectTip = true
      }
    },
    cancel () {
      this.$router.back()
    },
    sure () {
      this.$router.back()
      this.quit = true
    },
    nextUpdate () {
      this.$router.back()
    },
    nowUpdate () {
      this.$router.back()
      this.quit = true
    },
    getCityList () {
      axios.get(Common.staticHref() + 'mock/city.json')
      .then(this.getCityListSucc)
      .catch(this.getCityListError)
    },
    getCityListSucc (res) {
      var _res = res.data
      if (!_res.length > 0) return
      this.addressPicker = this.$createCascadePicker({
        title: '城市选择',
        data: _res,
        onSelect: this.selectHandle,
        onCancel: this.cancelHandle
      })
    },
    getCityListError (error) {
      console.log(error)
    },
    getWeather () {
      if (isLocal === 'local') {
        axios.post('/Calendar/api/weather/get/web/weather/', {
          'device_id': this.deviceId
        })
        .then(this.getWeatherSucc)
        .catch(this.getWeatherError)
      } else {
        axios.post(api + '/Calendar/api/weather/get/web/weather/', {
          'device_id': this.deviceId
        })
        .then(this.getWeatherSucc)
        .catch(this.getWeatherError)
      }
    },
    getWeatherSucc (res) {
      let _res = res.data
      console.log(_res)
    },
    getWeatherError (error) {
      console.log(error)
    },
    setLocation () {
      this.toast = this.$createToast({
        time: 0,
        txt: '更改中...',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/location/', {
          'device_id': localStorage.getItem('max_device_id'),
          'location_id': this.locationId
        })
        .then(this.setLocationSucc)
        .catch(this.setLocationError)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/location/', {
          'device_id': localStorage.getItem('max_device_id'),
          'location_id': this.locationId
        })
        .then(this.setLocationSucc)
        .catch(this.setLocationError)
      }
    },
    setLocationSucc (res) {
      this.toast.hide()
      let _res = res.data
      if (!_res) return
      if (_res.result === 0) {
        // this.$router.push({path: '/Setting'})
        this.showTip = true
        this.locationId = null
        if (this.city.length > 0) {
          let city = this.city.join('.')
          localStorage.setItem('max_city', city)
        }
      } else {
        console.log(_res.message)
      }
    },
    setLocationError (error) {
      this.toast.hide()
      console.log(error)
      this.toast = this.$createToast({
        txt: '地址设置失败',
        type: 'txt'
      }).show()
    }
  }
}
</script>
<style lang="stylus" scoped>
.cut
  position absolute
  z-index 2
  font-size 14px
  padding 10px
  right 15px
  top 15px
</style>


// WEBPACK FOOTER //
// src/pages/CitySelect/CitySelect.vue